import { observable, action, flow, computed } from 'mobx';
import { rstr2b64, hex_md5, Encrypts } from 'utils/md5';
import Util from 'utils';
import Config from 'config/Config';
import dayjs from 'dayjs';
import { Toast } from 'antd-mobile';
import Stores from 'config/Stores';
import Serv from './RegisterStoreServ';
class RegisterStoreMod {
  // 是否为会员开店
  @observable isMember = false;

  @observable isNormal = false;

  @observable userId = Stores.AppMod.userInfo.id;
  // 实体卡号、密码、电话
  @observable cardCode = Stores.AppMod.userType == 2 ? Stores.AppMod.userInfo.cardCode : '';

  @observable password = '';

  @observable phone = '';

  // 验证码、对应uniqueId、是否正在加载验证码
  @observable code = '';

  @observable uniqueId = '';

  @observable codeLoading = false;

  // 是否同意协议
  @observable isAgree = false;

  // 修改参数逻辑
  @action
  changeState(key, value) {
    this[key] = value;
  }

  /**
   * 重置表单数据
   */
  @action
  resetData() {
    this.cardCode = Stores.AppMod.userType == 2 ? Stores.AppMod.userInfo.cardCode : '';
    this.password = '';
    this.phone = '';
    this.code = '';
    this.uniqueId = '';
    this.codeLoading = false;
    this.isAgree = false;
  }

  /**
   * 获取验证码
   * @param {String} cardCode - 开店实体卡号
   * @param {String} password - 密码
   * @param {String} phone - 手机号
   */
  getVerifyCode = flow(function* (cardCode, password, phone, extObj) {
    const { imageCode } = extObj || {};
    const timestamp = new Date().getTime();
    try {
      if (!cardCode || !password) {
        Toast.info('请输入卡号和密码~', 1);
        return;
      }
      const params = {
        cardCode,
        password: rstr2b64(password),
        phone,
        descriptionType: 11, // 11 代表开店验证码场景
        channel: 3,
        areaCode: Stores.AppMod.areaCode,
        md5Sign: encodeURIComponent(
          Encrypts(
            timestamp +
              '#' +
              hex_md5((phone || this.phone).replace(/\s*/g, '') + Util.getSendMsgParamsUat()).toUpperCase()
          )
        )
      };
      imageCode && (params.imageCode = imageCode);
      const { data, resultMsg } = yield Serv.getVerifyCode(params);
      // if (+resultCode === 3333 && params.phone) {
      //   this.getCaptcha(params.phone);
      //   return resultCode;
      // }
      if (data) {
        Toast.info(resultMsg, 2);
        this.uniqueId = data.uniqueId;
        return data;
      }
      return null;
    } catch (error) {
      return null;
    }
  });

  /**
   * 获取图形二维码
   */
  getCaptcha = flow(function* (phone) {
    try {
      const data = yield Serv.getCaptcha(phone);
      return null;
    } catch (error) {}
  });

  /**
   * 校验图形二维码
   */
  getImageCode = flow(function* (code) {
    try {
      const result = yield Serv.getImageCode({
        imgCode: code,
        phone: this.phone
      });
      const { data } = result || {};
      return data;
    } catch (error) {}
  });

  /**
   * 检验卡密是否有效 - 注册店铺验证卡密（已登录会员注册店铺）
   */
  verifyStoreCard = flow(function* () {
    try {
      const { cardCode, password, phone, code, uniqueId, isNormal } = this;
      let params = {
        cardCode,
        password: rstr2b64(password)
      };
      let res = null;
      // 根据用户是已登录会员，请求不同接口
      if (this.isMember) {
        if (isNormal) {
          Object.assign(params, { phone: Stores.AppMod.userInfo.phone });
          res = yield Serv.verifyStoreCard_3(params);
          res.phone = Stores.AppMod.userInfo.phone;
        } else {
          res = yield Serv.verifyStoreCard_1(params);
        }
      } else {
        const timestamp = new Date().getTime();
        Object.assign(params, {
          phone,
          uniqueId,
          verifyCode: code,
          channel: 3,
          md5Sign: encodeURIComponent(
            Encrypts(
              timestamp + '#' + hex_md5(uniqueId.replace(/\s*/g, '') + Util.getSendMsgParamsUat()).toUpperCase()
            )
          )
        });
        res = yield Serv.verifyStoreCard_2({ ...params, areaCode: Stores.AppMod.areaCode });
      }
      return res;
    } catch (error) {
      return null;
    }
  });

  /**
   * 查询是否会员信息不全
   */
  checkMsgIsFull = flow(function* (cardCode, mode, cardTypeId) {
    try {
      const { data } = yield Serv.checkMsgIsFull(cardCode || this.cardCode, mode, cardTypeId);
      return data;
    } catch (error) {
      return null;
    }
  });
}
const registerStoreMod = new RegisterStoreMod();
export default registerStoreMod;



// WEBPACK FOOTER //
// ./src/pages/Register/RegisterStore/RegisterStoreMod.js